<template>
  <div class="c-preloader">

<!--     <header class="c-preloader__header">
      <span class="c-preloader__subtitle">Welcome to</span>
      <h1 class="c-preloader__title">The Changing Lawyer</h1>
      <p>LOADING...</p>
    </header> -->

    <div class="c-preloader__spinner">
      <div class="c-preloader__spinner-dot1"></div>
      <div class="c-preloader__spinner-dot2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading-animation'
}
</script>

<style lang="scss" scoped>
.c-preloader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  text-align: center;
  background-color: #BCE3E4;
}

.c-preloader__header {
  max-width: 600px;
  margin:  0 auto;
  color: #1D478D;
}

.c-preloader__title {
  margin: 2rem 0 1rem;
  font-family: Brandontxtbld, "Brandon Text", Helvetica, Arial, sans-serif;
  font-size: 2.6rem;
  font-weight: 700;
  line-height: .9;
  text-transform: uppercase;
  color: #1D478D;
}

.c-preloader__subtitle {
  background-color: #BBE3E4;
  display: block;
  font-family: Brandontxtbld, "Brandon Text", Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 16px;
  position: relative;
  width: 100%;
}

.c-preloader__subtitle:before,
.c-preloader__subtitle:after {
  content: "";
  position: absolute;
  top: 45%;
  width: 35%;
  height: 1px;
  background-color: #1D478D;
}
.c-preloader__subtitle:before {
  left: 0;
}
.c-preloader__subtitle:after {
  right: 0;
}

.c-preloader__spinner {
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;
  animation: sk-rotate 2.0s infinite linear;
}

.c-preloader__spinner-dot1,
.c-preloader__spinner-dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #F69848;
  border-radius: 100%;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.c-preloader__spinner-dot2 {
  top: auto;
  bottom: 0;
  animation-delay: -1.0s;
}

@keyframes sk-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0.0);
  }
  50% {
    transform: scale(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// LoadingAnimation.vue?4e783da0